const SETTINGS_RETURN_KEY = "brixigo.settingsReturnTo";

export const SETTINGS_HOME_PATH = "/settings";

export function isSettingsPath(pathname) {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  if (path === "/settings" || path.startsWith("/settings/")) return true;
  if (path.startsWith("/salary-v2/")) return true;
  if (path.startsWith("/statutory/")) return true;
  if (path === "/attendance/roster" || path.startsWith("/attendance/roster/")) return true;
  if (path === "/payrollhome") return true;
  if (path.startsWith("/tools/")) return true;
  return false;
}

/**
 * Edit opens /salary/templates/:id only long enough to load the structure,
 * then replaces that URL with the wizard. It must not become the
 * "Back to Main Sidebar" target, or that click reopens the same editor.
 */
export function isSalaryTemplateHandoffPath(pathname) {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  return path === "/salary/templates" || /^\/salary\/templates\/[^/]+$/.test(path);
}

/** Remember where the user was before opening Settings (once per visit). */
export function rememberSettingsReturnPath(fromPathname) {
  if (!fromPathname || isSettingsPath(fromPathname) || isSalaryTemplateHandoffPath(fromPathname)) return;
  sessionStorage.setItem(SETTINGS_RETURN_KEY, fromPathname);
}

/** Target route after Close Settings — leaves all /settings/* pages. */
export function consumeSettingsReturnPath() {
  const raw = sessionStorage.getItem(SETTINGS_RETURN_KEY);
  sessionStorage.removeItem(SETTINGS_RETURN_KEY);
  if (raw && !isSettingsPath(raw) && !isSalaryTemplateHandoffPath(raw)) return raw;
  return "/dashboard";
}

/**
 * After a successful settings form save — return to All Settings hub
 * (not the dashboard).
 */
export function navigateToSettingsHome(navigate, { replace = true } = {}) {
  if (typeof navigate !== "function") return;
  navigate(SETTINGS_HOME_PATH, { replace });
}
